import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';

import { PrimaryButton, SecondaryButton } from '../../components/button/Button';
import { performSessionCleanup, safeRedirectToLogin } from '../../authentication/sessionCleanup.js';

import '../../pages/error-pages/errorPages.css';

/** In a shell's content area when the user's profile and permissions could not be loaded (useWorkspaceBootstrap). */
const WorkspaceLoadError = ({ onRetry }) => {
    const signInAgain = async () => {
        await performSessionCleanup();
        safeRedirectToLogin();
    };

    return (
        <div className="error-page">
            <div className="error-card" role="alert">
                <div className="error-icon error-icon--error" aria-hidden="true">
                    <FontAwesomeIcon icon={faTriangleExclamation} />
                </div>
                <h1>We Couldn't Load Your Workspace</h1>
                <p>Check your connection, then try again.</p>
                <p className="error-subtle">
                    We'll also try again when your connection is back. If it keeps happening, sign in again.
                </p>
                <div className="error-actions">
                    <PrimaryButton onClick={onRetry}>Try Again</PrimaryButton>
                    <SecondaryButton onClick={signInAgain}>Sign In Again</SecondaryButton>
                </div>
            </div>
        </div>
    );
};

export default WorkspaceLoadError;
